// extracted by mini-css-extract-plugin
export default {"line1":"SkeletonMainSeasonalSlider_line1__XwKRX","line2":"SkeletonMainSeasonalSlider_line2__6lH7X"};